import axios from "axios";
import events from "@/libs/events";
import EventBus from "@/libs/event-bus";

axios.defaults.withCredentials = true;

const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";
const prodServer = "https://gramotacafe.ru";
const devServer = "http://gramota-press.loc:8080";
const authServer = browserOrigin || (process.env.NODE_ENV == "development" ? devServer : prodServer);

axios.defaults.baseURL = authServer;

const user = {
    isAuthorized(){
        return localStorage.getItem('user_id') > 0;
    },
    logoff(){
        localStorage.removeItem('user_id');
        axios.post("/api/auth/logout");
        EventBus.$emit(events.LOGOFF);
    },
    login(username, password){
        return new Promise((resolve, reject) => {

            axios.get('/sanctum/csrf-cookie').then(() => {
                // Login через API

                axios.post("/api/auth/login", {
                    email: username,
                    password
                }).then(response => {
                    if (response.data.user_id) {
                        localStorage.setItem('user_id', response.data.user_id);
                        resolve(response);
                    } else {
                        reject(new Error('Invalid response format'));
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
            }).catch(err => {
                console.error('CSRF error:', err);
                reject(err);
            });

        })

    },

    setCSRF(){

    }
};
EventBus.$on(events.STATUS_401_UNAUTHORIZED, () =>{
    localStorage.removeItem('user_id');
});
export {
    user
}
